import { html } from "lit";

export const ProductDetailFootnotes = () => html`
    <div class="ux-t-container footnotes">
        <p class="footnotes-element-npi text-tiny">
            Je nach Land sind Abweichungen von diesem Produktsortiment und von
            diesen Angaben möglich. Änderungen in Technik, Ausstattung, Preis
            und Zubehörangebot sind vorbehalten. Bitte setzen Sie sich mit Ihrem
            Ansprechpartner vor Ort in Verbindung, um zu erfahren, ob das
            Produkt in Ihrem Land verfügbar ist.
        </p>
    </div>
`;
